module.exports = __webpack_public_path__ + "static/media/BG_71.9f0fb88d.png";